import { UserRole } from '@stores/User/types';
import { ListTypeEnum } from '@screens/Authenticated/Property/PropertyListScreen/types';

export enum AuthenticatedTabs {
  IMOVEIS = 'Imóveis',
  ARQUIVOS = 'Arquivos',
  CONFIGURACOES = 'Configurações',
  CONTA = 'Conta'
}

export const ALL_MENUS: {
  [key in AuthenticatedTabs]: {
    to: string;
    label: string;
    access: UserRole[];
  }[];
} = {
  [AuthenticatedTabs.IMOVEIS]: [
    {
      label: 'Imóveis Ativos',
      to: `/area-do-corretor/imoveis/listagem/${ListTypeEnum.ATIVOS}`,
      access: [UserRole.ADMIN, UserRole.SECRETARIA, UserRole.CORRETOR]
    },
    {
      label: 'Cadastrar Imóvel',
      to: '/area-do-corretor/imoveis/novo-cadastro',
      access: [UserRole.ADMIN, UserRole.SECRETARIA, UserRole.CORRETOR]
    },
    {
      label: 'Aprovar Imóveis',
      to: `/area-do-corretor/imoveis/listagem/${ListTypeEnum.APROVANDO}`,
      access: [UserRole.ADMIN]
    },
    {
      label: 'Imóveis em Aprovação',
      to: `/area-do-corretor/imoveis/listagem/${ListTypeEnum.APROVANDO}`,
      access: [UserRole.SECRETARIA, UserRole.CORRETOR]
    },
    {
      label: 'Destaques',
      to: `/area-do-corretor/imoveis/listagem/${ListTypeEnum.DESTAQUES}`,
      access: [UserRole.ADMIN]
    },
    {
      label: 'Em Negociação',
      to: `/area-do-corretor/imoveis/listagem/${ListTypeEnum.NEGOCIANDO}`,
      access: [UserRole.ADMIN]
    },
    {
      label: 'Imóveis Inativos',
      to: `/area-do-corretor/imoveis/listagem/${ListTypeEnum.INATIVOS}`,
      access: [UserRole.ADMIN]
    }
  ],
  [AuthenticatedTabs.ARQUIVOS]: [
    {
      label: 'Arquivados',
      to: `/area-do-corretor/arquivos/${ListTypeEnum.ARQUIVADOS}`,
      access: [UserRole.ADMIN]
    },
    {
      label: 'Vendidos',
      to: `/area-do-corretor/arquivos/${ListTypeEnum.VENDIDOS}`,
      access: [UserRole.ADMIN]
    },
    {
      label: 'Alugados',
      to: `/area-do-corretor/arquivos/${ListTypeEnum.ALUGADOS}`,
      access: [UserRole.ADMIN]
    }
  ],

  [AuthenticatedTabs.CONFIGURACOES]: [
    {
      label: 'Código de Imóvel',
      to: '/area-do-corretor/configuracoes/codigo-de-imovel',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Tipo de Imóvel',
      to: '/area-do-corretor/configuracoes/tipos-de-imoveis',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Chaves',
      to: '/area-do-corretor/configuracoes/chaves',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Condições de Imóvel',
      to: '/area-do-corretor/configuracoes/condicoes',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Cidades e UF',
      to: '/area-do-corretor/configuracoes/cidades-atendidas',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Características de Imóvel',
      to: '/area-do-corretor/configuracoes/caracteristicas',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Usuários',
      to: '/area-do-corretor/configuracoes/usuarios',
      access: [UserRole.ADMIN]
    },
    {
      label: 'Configurações do Sistema',
      to: '/area-do-corretor/configuracoes/dados-da-empresa',
      access: [UserRole.ADMIN]
    }
  ],
  [AuthenticatedTabs.CONTA]: []
};
